import { ChangeDetectionStrategy, Component, OnInit, input, inject } from '@angular/core';
import { BazisLoaderService } from '@bazis/shared/services/loader.service';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { SafePipe } from '@bazis/shared/pipes/safe.pipe';

@Component({
    selector: 'bazis-global-loader',
    templateUrl: './global-loader.component.html',
    imports: [CommonModule, TranslocoModule, SafePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalLoaderComponent implements OnInit {
    public loaderService = inject(BazisLoaderService);

    readonly centerX = input(25);

    readonly centerY = input(25);

    readonly radius = input(14);

    readonly loader = input<'spinner' | 'dots'>('spinner');

    readonly amountDots = input(5);

    readonly hasBackdrop = input(false);

    ngOnInit(): void {}
}
